export default "__VITE_ASSET__t8EQ$1jt__"